import { RouterStateSnapshot, Router } from "@angular/router";
import {dashboardUrl} from "../inventory/route";

export class GuardUtils {
  public static isExternalNavigation(state: RouterStateSnapshot): boolean {
    // Simple check: If no referrer or referrer is from different domain, it's external navigation
    return !document.referrer || document.referrer.indexOf(window.location.origin) === -1;
  }

  public static handleAccessControl(hasAccess: boolean, router: Router, state: RouterStateSnapshot,): boolean {
    if (hasAccess) {
      return true;
    } else {
      // Check if navigation is from external URL paste (new page) vs internal navigation
      const isExternalNavigation = GuardUtils.isExternalNavigation(state);
      if (isExternalNavigation) {
        // Redirect to dashboard only for external URL paste
        router.navigate([dashboardUrl]);
      }
      // For internal navigation (clicking links), just return false without redirecting
      return false;
    }
  }
}
